import { render, staticRenderFns } from "./home_pc.vue?vue&type=template&id=2f29af4e&scoped=true"
import script from "./home_pc.vue?vue&type=script&lang=js"
export * from "./home_pc.vue?vue&type=script&lang=js"
import style0 from "./home_pc.vue?vue&type=style&index=0&id=2f29af4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f29af4e",
  null
  
)

export default component.exports